module.exports = __webpack_public_path__ + "img/service.264cd2ed.png";